import {
  API_HEADER,
  API_URL,
  Identifier,
} from "@modules/shared/enums/common-enum";
import { ErrorEntity } from "@modules/shared/entities/errors/error.entity";
import { AuthenticationEntity } from "../entities/auth.entity";

export class AuthenticationService {
  async login(identifier: string, password: string, loginType: Identifier) {
    const res: Response = await fetch(`${API_URL.AUTH_SIGN_IN}`, {
      method: "POST",
      headers: API_HEADER,
      body: JSON.stringify({
        identifier: identifier,
        password,
        login_type: loginType.toString(),
      }),
    });

    const data = await res.json();

    if (data.status_code !== 201)
      return new ErrorEntity(
        data.status_code,
        data.message.code,
        data.message.type,
        data.message.details,
        data.message.title,
        data.message.subtitle,
      );

    const login = new AuthenticationEntity(
      data.data.access_token,
      data.data.refresh_token,
    );

    return login;
  }

  async refresh(refreshToken: string) {
    try {
      const res: Response = await fetch(`${API_URL.AUTH_REFRESH}`, {
        method: "POST",
        headers: {
          ...API_HEADER,
          Authorization: "Bearer " + refreshToken,
        },
      });

      if (!res.ok) {
        // Handle HTTP errors (4xx, 5xx)
        return new ErrorEntity(
          res.status,
          "NETWORK_ERROR",
          "error",
          "HTTP Error",
          "Request failed",
          "",
        );
      }

      const data = await res.json();
      if (data.status_code !== 201) {
        return new ErrorEntity(
          data.status_code,
          data.message.code,
          data.message.type,
          data.message.details,
          data.message.title,
          data.message.subtitle,
        );
      }

      return new AuthenticationEntity(data.data.access_token, refreshToken);
    } catch (error) {
      // Handle network/parsing errors
      return new ErrorEntity(
        0,
        "NETWORK_ERROR",
        "error",
        "Network failed",
        "",
        "",
      );
    }
  }

  async logout(accessToken: string) {
    const res: Response = await fetch(`${API_URL.AUTH_SIGN_OUT}`, {
      method: "POST",
      headers: {
        ...API_HEADER,
        Authorization: "Bearer " + accessToken,
      },
    });

    if (res.status !== 201) return false;

    return true;
  }

  async signUp(
    name: string,
    phoneNumber: string,
    email: string,
    password: string,
    secretKey: string,
  ) {
    const res: Response = await fetch(`${API_URL.AUTH_SIGN_UP}`, {
      method: "POST",
      headers: API_HEADER,
      body: JSON.stringify({
        name: name,
        phone_number: phoneNumber,
        email: email,
        password: password,
        country_code: "+84",
        verify_type: "email",
        secret_key: secretKey,
      }),
    });

    const data = await res.json();

    if (data.status_code !== 201)
      return new ErrorEntity(
        data.status_code,
        data.message.code,
        data.message.type,
        data.message.details,
        data.message.title,
        data.message.subtitle,
      );

    return new AuthenticationEntity(
      data.data.access_token,
      data.data.refresh_token,
    );
  }
}
